import React from 'react';
import RestaurantDashboard from '../../../components/admin/restaurantManagement/RestaurantDashboard';
import '../../../styles/adminScreen.css';

const RestaurantScreen = () => {
  return (
    <div className="admin-screen">
      <RestaurantDashboard />
    </div>
  );
};

export default RestaurantScreen;
